import { Button } from "@manifesthhqinc/ui-library";
import { BodyLargeRegular, HeadlineMedium } from "../../../components/font";
import Footer from "../../../components/footer";
import HenryAvator from "../../../components/henry/HenryAvator";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import Flex from "../../../layout/flex";
import ScrollableContainer from "../../../layout/scrollable-container";
import { HenryAvatorDiv, HenryIntroContainer } from "../../henry-questionniare/screens/styles";
import { UseExploreIRAOptionsType } from "../useExploreIRAOptions";

const IRAOptionIntroScreen = (props: UseExploreIRAOptionsType) => {
  const { onClickStart } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="ira-explore-intro">
        <Container fullHeight>
          <HenryIntroContainer>
            <HenryAvatorDiv $marginBottom={24}>
              <HenryAvator height={100} width={100} />
            </HenryAvatorDiv>
            <Flex $flexDirection="column" $flexGap={8}>
              <HeadlineMedium $textAlign="center">Let’s find the best IRA for you</HeadlineMedium>
              <BodyLargeRegular $textAlign="center">
                With so many IRA options available, I’ll ask a few quick questions to help match you with the best one
                for your needs.
              </BodyLargeRegular>
            </Flex>
          </HenryIntroContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button onClick={onClickStart} size="large" name="startIRAQuestionnaire">
          Let's begin
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default IRAOptionIntroScreen;
